import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=4f9e8ffa&scoped=true"
import script from "./DateSelect.vue?vue&type=script&lang=ts"
export * from "./DateSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.99.8__lodash@4.17.21_prettier@2.8.8_vue-_69bc0556815cefdff9c73fe5644cf446/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e8ffa",
  null
  
)

/* custom blocks */
import block0 from "./DateSelect.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports